import { Container, Grid } from '@material-ui/core';
import React from 'react';
import './info.scss';

export const Info: React.FC = () => (
  // <></> // todo: omment all below and uncomment this line to remove the info banner
  <>
    <div className="">
      <Container className="info-bar__container">
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
        >
          <p>If you are experiencing delays in returning search results, please try
            <a
              href="https://www.sheepgenetics.org.au/globalassets/sheep-genetics/resources/brochures-and-fact-sheets/clearing-the-cache.pdf"
              target="_blank"
              rel="noreferrer"
            > clearing the cache
            </a>.
          </p>
        </Grid>
      </Container>
    </div>
    {/* todo: If we want to display Important message we use the below code to set the orange banner */}
    {/* <div className="sg-info-bar"> */}
    {/*  <Container className="info-bar__container"> */}
    {/*    <Grid */}
    {/*      container */}
    {/*      item */}
    {/*      xs={12} */}
    {/*      sm={12} */}
    {/*      md={12} */}
    {/*    > */}
    {/*      <h4> */}
    {/*        <br />27/06/2025 - Please note that the AGBU servers are undergoing routine maintenance. */}
    {/*        The <strong>DQS</strong> report will be unavailable during this process. */}
    {/*        <br /><br /> */}
    {/*      </h4> */}
    {/*    </Grid> */}
    {/*  </Container> */}
    {/* </div> */}
  </>
);
